import React, { useRef } from "react";
import { withRouter } from "react-router-dom";

const CookiesModalContext = React.createContext({
  refModal: null,
});
export default CookiesModalContext;

export const CookiesModalContextProvider = withRouter((props) => {
  const { children } = props;

  const refModal = useRef(null);
  const lastFocusedElementRef = useRef(null);

  const handleOpenCookiesModal = (e) => {
    const target = e?.currentTarget;

    if (typeof document !== "undefined") {
      if (target && typeof target.focus === "function") {
        lastFocusedElementRef.current = target;
      } else {
        lastFocusedElementRef.current = document.activeElement;
      }

      if (refModal.current) {
        refModal.current.openModal();
      }
    }
  };
  const restoreFocus = () => {
    const element = lastFocusedElementRef.current;

    if (typeof document !== "undefined" && element && typeof element.focus === "function") {
      element.focus();
    }
  };

  const handleCloseCookiesModal = () => {
    if (typeof window !== "undefined" && refModal.current) {
      if (refModal.current) {
        refModal.current.closeModal();
      }
      restoreFocus();
    }
  };

  return (
    <CookiesModalContext.Provider
      value={{
        refModal,
        handleOpenCookiesModal,
        handleCloseCookiesModal,
      }}
    >
      {children}
    </CookiesModalContext.Provider>
  );
});
